import React, { useState, useEffect, forwardRef } from 'react'
import { useHistory } from "react-router"
import IconButton from '@mui/material/IconButton'
import { Container, InputLabel, Button, Grid, Typography, Box, Snackbar } from "@mui/material"
import makeStyles from "@mui/styles/makeStyles"
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import Visibility from '@mui/icons-material/Visibility'
import InputAdornment from '@mui/material/InputAdornment'
import OutlinedInput from '@mui/material/OutlinedInput'
import { Person, VpnKey } from '@mui/icons-material'
import { FormHelperText } from '@mui/material'
import MuiAlert from "@mui/material/Alert"
import MaintenanceNotice from '../components/MaintenanceNotice'
import Helper from '../providers/Helpers'
import commandsProvider from '../providers/CommandsProvider'
import { useSnackbar } from '../providers/SnackbarProvider'

const useStyles = makeStyles((theme) => {
    return {
        text: {
            [theme.breakpoints.up('sm')]: {},
            [theme.breakpoints.down('sm')]: {
                textAlign: "center"
            }
        }
    }
})

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function WebLogin(props) {
    const classes = useStyles();
    const [email, setName] = useState("")
    const [password, setPassword] = useState("")
    const [nameError, setNameError] = useState(false)
    const [passwordError, setPasswordError] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [nameErrorText, setNameErrorText] = useState("")
    const [passwordErrorText, setPasswordErrorText] = useState("")
    const [userNotFound, setUserNotFound] = useState(false)

    const [open, setOpen] = useState(false)
    const [severity, setSeverity] = useState("")
    const [message, setMessage] = useState("")

    const { openSnackbar } = useSnackbar();

    const history = useHistory()


    const handleSubmit = (e) => {
        e.preventDefault()
        props.setIsLoading(true);

        if (email === '') {
            setNameError(true)
            setNameErrorText("Insira o Email")
            props.setIsLoading(false);
        }
        else {
            setNameError(false)
            setNameErrorText("")
        }

        if (password === '') {
            setPasswordError(true)
            setPasswordErrorText("Insira a Senha")
            props.setIsLoading(false);
        }
        else {
            setPasswordError(false)
            setPasswordErrorText("")
        }

        if (email && password) {
            const uri = `${process.env.REACT_APP_URL}/account/login/web?email=${encodeURIComponent(email)}&sENHA=${encodeURIComponent(password)}`
            //const encoded = encodeURI(uri)  // Comentado para resolver o problema do 
            fetch(uri, {
                //mode: 'cors',
                method: "GET",
                //credentials: "include",
                headers: { "content-type": "application/json", 'Access-Control-Allow-Origin': '*' },
            })
                .then(res => {
                    if (res.status === 404) {
                        setUserNotFound(true)
                        props.setIsLoading(false);
                        res.json().then(
                            (data) => {
                                if (data.message) {
                                    openSnackbar(data.message, "error");
                                }
                            }
                        )
                    } else {
                        res.json()
                            .then(data => {
                                if (data.message) {
                                    props.token.setToken(data.message)
                                    props.setIsLoading(false);
                                } else {

                                    // Teste se o usuário tem o papel 'light'
                                    if (data.user.role && data.user.role.light === true)
                                    {
                                        openSnackbar("Acesso negado! Verifique o status da sua licença", "error");
                                        console.log("Usuário light detectado!");
                                        props.setIsLoading(false);
                                    }
                                    else
                                    {
                                        //props.data.setPort(port)
                                        localStorage.setItem("user", JSON.stringify(data.user))
                                        localStorage.setItem("token", data.token)

                                        props.data.setToken(data.token)
                                        commandsProvider.setSession(Helper.ConvertUserToSession(Helper.GetUserFromLocalStorage()));
                                        props.data.setUserData(Helper.ConvertUserToSession(Helper.GetUserFromLocalStorage()))
                                        props.data.populateData(data.user, data.token)

                                        if (data.user.iD_EMPRESA === "00000000-0000-0000-0000-000000000000") {
                                            history.push("/primeiro+login")
                                        }
                                        else if (data.user.role.revenda === true || data.user.role.delta === true || data.user.role.multiCentral === true) {
                                            history.push("/painel")
                                        } else {
                                            sessionStorage.setItem("serialConnected", "conected")
                                            history.push("/central")
                                        }
                                    }
                                }
                            })
                    }
                })
                .catch(err => console.log(err))
        }
    }

    const setVisible = () => {
        setShowPassword(!showPassword)
    }


    return (
        <Box>
            {process.env.REACT_APP_MAINTENANCE === 'true' ? (
                <Container>
                    <MaintenanceNotice />
                </Container>
            ) : (
                <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <Container color="#212121">
                        <Snackbar
                            open={open}
                            autoHideDuration={6000}
                            onClose={() => setOpen(!open)}>
                            <Alert severity={severity} sx={{ width: '100%' }}>{message}</Alert>
                        </Snackbar>
                        <Grid container spacing={2}>

                            <Grid item xs={12} md={12} lg={12} className={classes.text}>
                                <Typography variant='h3' color='#929292'>Login</Typography>
                            </Grid>

                            <Grid item xs={12} md={12} lg={12} className={classes.text}>
                                <InputLabel sx={{ color: "#929292" }} htmlFor="usern-email">E-mail:</InputLabel>
                                <OutlinedInput
                                    fullWidth={true}
                                    autoFocus={true}
                                    id="usern-email"
                                    onChange={(e) => setName(e.target.value)}
                                    variant="outlined"
                                    color="secondary"
                                    placeholder="Email"
                                    required
                                    error={nameError}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <Person />
                                        </InputAdornment>
                                    }
                                ></OutlinedInput>
                                <FormHelperText id="user-email">{nameErrorText}</FormHelperText>
                            </Grid>

                            <Grid item xs={12} md={12} lg={12} className={classes.text}>
                                <InputLabel sx={{ color: "#929292" }} htmlFor="outlined-adornment-password">Senha:</InputLabel>
                                <OutlinedInput
                                    fullWidth={true}
                                    required
                                    onChange={(e) => setPassword(e.target.value)}
                                    id="password"
                                    type={showPassword ? "text" : "password"}
                                    error={passwordError}
                                    placeholder="Senha"
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <VpnKey />
                                        </InputAdornment>
                                    }
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={setVisible}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                                <FormHelperText id="password">{passwordErrorText}</FormHelperText>
                            </Grid>

                            {userNotFound == false ? null : <Grid item xs={12} md={12} lg={12}><Typography variant='body2' color='#d32f2f'>E-mail e/ou Senha Incorretos!</Typography></Grid>}

                            <Grid item xs={12} md={12} lg={12} className={classes.text} marginTop={"5px"}>
                                <Button
                                    fullWidth={true}
                                    type="submit"
                                    color="secondary"
                                    variant="contained"
                                    disabled={props.isLoading}
                                >
                                    Entrar
                                </Button>
                            </Grid>
                        </Grid>
                    </Container>
                </form>
            )}
        </Box>
    );
}